import { render } from "./Parents.vue?vue&type=template&id=368812bb&scoped=true"
import script from "./Parents.vue?vue&type=script&lang=js"
export * from "./Parents.vue?vue&type=script&lang=js"

import "./Parents.vue?vue&type=style&index=0&id=368812bb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-368812bb"]])

export default __exports__